document.addEventListener('change', event => {
 if (event.target.id !== 'reed-size') return;
 for (const row of document.querySelectorAll('[data-size-row]')) {
  row.dataset.selected = String(row.dataset.sizeRow === event.target.value);
 }
});
document.addEventListener('click', event => {
 const zoom = event.target.closest('[data-gallery-zoom]');
 if (zoom) {
  const gallery = zoom.closest('[data-product-gallery]');
  const source = gallery.querySelector('#reed-pdp-image');
  const dialog = gallery.querySelector('dialog');
  const enlarged = dialog.querySelector('img');
  enlarged.src = source.src;
  enlarged.alt = source.alt;
  dialog.showModal();
  return;
 }
 const close = event.target.closest('[data-gallery-close]');
 if (close) { close.closest('dialog').close(); return; }
 if (event.target.matches('.reed-pdp-lightbox')) {
  const rect = event.target.getBoundingClientRect();
  if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  return;
 }
 const button = event.target.closest('[data-gallery-src]');
 if (!button) return;
 const gallery = button.closest('[data-product-gallery]');
 const image = gallery.querySelector('#reed-pdp-image');
 image.src = button.dataset.gallerySrc;
 image.alt = button.dataset.galleryAlt;
 gallery.querySelector('#reed-pdp-view').textContent = button.dataset.galleryCaption;
 for (const thumbnail of gallery.querySelectorAll('[data-gallery-src]')) {
  thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
 }
});

document.addEventListener('click',event=>{
 const button=event.target.closest('.reed-model-toggle');
 if(!button)return;
 const media=button.closest('[data-model-preview]');
 media.classList.add('has-manual-view');
 const active=media.classList.toggle('is-model-view');
 button.setAttribute('aria-pressed',String(active));
 button.querySelector('span').textContent=active?'Product view':'On model';
 const name=media.querySelector('a').getAttribute('aria-label').replace(/^View /,'');
 button.setAttribute('aria-label',active?'Show '+name+' product view':'Show '+name+' on a model');
});

(()=>{
 const video=document.getElementById('reed-film-video'),button=document.querySelector('.reed-film-toggle');
 if(!video||!button)return;
 const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');
 const update=()=>{button.innerHTML='<span aria-hidden="true" class="reed-film-icon"></span>';button.classList.toggle('is-paused',video.paused);button.setAttribute('aria-label',video.paused?'Play background video':'Pause background video');};
 video.muted=true;
 const applyMotion=()=>{if(reduceMotion.matches){video.autoplay=false;video.pause();}else video.play().catch(update);};
 button.addEventListener('click',()=>{if(video.paused)video.play().catch(update);else video.pause();});
 video.addEventListener('play',update);video.addEventListener('pause',update);reduceMotion.addEventListener('change',applyMotion);applyMotion();update();
})();

for(const form of document.querySelectorAll('.reed-tracking-form'))form.addEventListener('submit',event=>{event.preventDefault();const number=new FormData(form).get('number').trim();if(!/^[A-Za-z0-9 -]{5,64}$/.test(number))return;let result=form.nextElementSibling;if(!result?.classList.contains('reed-tracking-result')){result=document.createElement('div');result.className='reed-tracking-result';form.after(result);}result.replaceChildren();const a=document.createElement('a');a.href='https://t.17track.net/en#nums='+encodeURIComponent(number.replace(/ /g,''));a.target='_blank';a.rel='noopener noreferrer';a.textContent='Track '+number+' with 17TRACK ↗';const p=document.createElement('p');p.textContent='Clicking shares your tracking number with the independent 17TRACK service.';result.append(a,p);});
const style=new URLSearchParams(location.search).get('style');const groups={cropped:['cropped-leather-biker'],relaxed:['relaxed-leather-bomber','shearling-collar-aviator'],longline:['belted-leather-field-jacket','longline-leather-trench']};if(location.pathname.includes('/collections/')&&groups[style])for(const item of document.querySelectorAll('[data-handle]'))item.hidden=!groups[style].includes(item.dataset.handle);